<template>
    <el-dialog v-dialogDrag  class="dialog" width="500px"
               :visible.sync="dialogVisible"
               append-to-body @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                系列号
            </div>
        </div>
        <div class="dialog_body" style="text-align: center">
            <el-input style="width: 300px;margin: 30px" v-model="serialNo" placeholder="请扫描或输入产品系列号"
                      close-on-click-modal="false" @keyup.enter.native="addSerialNo" ></el-input>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        data() {
            return {
                dialogVisible: true,
                dialoading: false,
                serialNo:"",
                formLabelWidth: '80px',
            };
        },
        mounted() {
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            addSerialNo() {
                let serialNo=this.serialNo;
                if(serialNo==null || serialNo===''){
                    this.$message({message: '请扫描或输入产品系列号', type: 'error'});
                    return false;
                }
                this.serialNo="";
                this.$emit('addSerialNo', serialNo);
            },
        }
    }
</script>

